const SECRET_KEY = 'doubt-atlas.v1.deviceSecret';
const CONSENT_KEY = 'doubt-atlas.v1.consent';

function bytesToHex(bytes: Uint8Array): string {
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}

function hexToBytes(hex: string): Uint8Array {
  const out = new Uint8Array(hex.length / 2);
  for (let i = 0; i < out.length; i += 1) out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  return out;
}

async function sha256(text: string): Promise<string> {
  const data = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return bytesToHex(new Uint8Array(hash));
}

export async function getDeviceIdentity() {
  let secret = localStorage.getItem(SECRET_KEY);
  if (!secret || !/^[a-f0-9]{64}$/.test(secret)) {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    secret = bytesToHex(bytes);
    localStorage.setItem(SECRET_KEY, secret);
  }
  const deviceHash = await sha256(`doubt-atlas:v1:${bytesToHex(hexToBytes(secret))}`);
  return { deviceHash, shortHash: `${deviceHash.slice(0, 6)}…${deviceHash.slice(-4)}` };
}

export function hasConsent(version: string): boolean {
  try {
    const stored = JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null') as { version?: string } | null;
    return stored?.version === version;
  } catch {
    return false;
  }
}

export function saveConsent(version: string, line: string): void {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ version, line, at: new Date().toISOString() }));
}

export async function attentionChecksum(input: string): Promise<string> {
  return sha256(`attention:${input}`);
}
